import { useFetcher } from "~/hooks/useFetcher";
import CeConfigResponse from "~/types/interfaces/ce-config";

const useDefaultConfig = () => {
  return useFetcher<CeConfigResponse>("/api/cohort-explorer/configurator/configs/default", {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
  });
};

export default useDefaultConfig;
